export const templateLoopParser = (list, template) => {
  let parsedTemplate = "";
  list.forEach((item) => {
    const keys = Object.keys(item);
    let templateToProcess = template;
    keys.forEach((key) => {
      try {
        // Use replaceAll to replace all occurrences of the placeholder
        templateToProcess = templateToProcess.replaceAll(`{{${key}}}`, `${item[key]}`);
      } catch (e) {
        console.error("Could not replace template", e);
      }
    });
    parsedTemplate += templateToProcess;
  });
  return `${parsedTemplate}`;
};
